export default __webpack_public_path__ + "static/media/treeSelect.4601ddcb.less";